module.exports = __webpack_public_path__ + "img/clothes_3.2647f0cd.jpg";